import { createClient } from "@supabase/supabase-js";

export const supabaseClient = createClient(
  `${process.env.REACT_APP_SUPABASE_PROJECT_KEY}`,
  `${process.env.REACT_APP_SUPABASE_API_KEY}`
);
